import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface Region {
	name: string;
	timeZoneId: string;
}

const TIMEZONE_MAPPING: Record<string, { name: string; timeZoneId: string }[]> = {
	Afghanistan: [{ name: 'Kabul', timeZoneId: 'Afghanistan Standard Time' }],
	'Åland Islands': [{ name: 'Mariehamn', timeZoneId: 'FLE Standard Time' }],
	Albania: [{ name: 'Tirana', timeZoneId: 'Central Europe Standard Time' }],
	Algeria: [{ name: 'Algiers', timeZoneId: 'W. Central Africa Standard Time' }],
	'American Samoa': [{ name: 'Pago Pago', timeZoneId: 'UTC-11' }],
	Andorra: [{ name: 'Andorra la Vella', timeZoneId: 'W. Europe Standard Time' }],
	Angola: [{ name: 'Luanda', timeZoneId: 'W. Central Africa Standard Time' }],
	Anguilla: [{ name: 'The Valley', timeZoneId: 'SA Western Standard Time' }],
	Antarctica: [{ name: 'Palmer', timeZoneId: 'Pacific SA Standard Time' }],
	'Antigua and Barbuda': [{ name: "Saint John's", timeZoneId: 'SA Western Standard Time' }],
	Argentina: [{ name: 'Buenos Aires', timeZoneId: 'Argentina Standard Time' }],
	Armenia: [{ name: 'Yerevan', timeZoneId: 'Caucasus Standard Time' }],
	Aruba: [{ name: 'Oranjestad', timeZoneId: 'SA Western Standard Time' }],
	Australia: [
		{ name: 'Canberra', timeZoneId: 'AUS Eastern Standard Time' },
		{ name: 'Sydney', timeZoneId: 'AUS Eastern Standard Time' },
		{ name: 'Melbourne', timeZoneId: 'AUS Eastern Standard Time' },
		{ name: 'Brisbane', timeZoneId: 'E. Australia Standard Time' },
		{ name: 'Adelaide', timeZoneId: 'Cen. Australia Standard Time' },
		{ name: 'Perth', timeZoneId: 'W. Australia Standard Time' },
		{ name: 'Hobart', timeZoneId: 'Tasmania Standard Time' },
		{ name: 'Darwin', timeZoneId: 'AUS Central Standard Time' },
		{ name: 'Lord Howe Island', timeZoneId: 'Lord Howe Standard Time' },
		{ name: 'Broken Hill', timeZoneId: 'Cen. Australia Standard Time' },
	],
	Austria: [{ name: 'Vienna', timeZoneId: 'W. Europe Standard Time' }],
	Azerbaijan: [{ name: 'Baku', timeZoneId: 'Azerbaijan Standard Time' }],
	Bahamas: [{ name: 'Nassau', timeZoneId: 'Eastern Standard Time' }],
	Bahrain: [{ name: 'Manama', timeZoneId: 'Arab Standard Time' }],
	Bangladesh: [{ name: 'Dhaka', timeZoneId: 'Bangladesh Standard Time' }],
	Barbados: [{ name: 'Bridgetown', timeZoneId: 'SA Western Standard Time' }],
	Belarus: [{ name: 'Minsk', timeZoneId: 'Belarus Standard Time' }],
	Belgium: [{ name: 'Brussels', timeZoneId: 'Romance Standard Time' }],
	Belize: [
		{
			name: 'Belize City',
			timeZoneId: 'Central America Standard Time',
		},
	],
	Benin: [
		{
			name: 'Porto-Novo',
			timeZoneId: 'W. Central Africa Standard Time',
		},
	],
	Bermuda: [{ name: 'Hamilton', timeZoneId: 'Atlantic Standard Time' }],
	Bhutan: [{ name: 'Thimphu', timeZoneId: 'Bangladesh Standard Time' }],
	Bolivia: [{ name: 'La Paz', timeZoneId: 'SA Western Standard Time' }],
	'Bonaire, Sint Eustatius and Saba': [{ name: 'Kralendijk', timeZoneId: 'SA Western Standard Time' }],
	'Bosnia and Herzegovina': [{ name: 'Sarajevo', timeZoneId: 'Central European Standard Time' }],
	Botswana: [{ name: 'Gaborone', timeZoneId: 'South Africa Standard Time' }],
	Brazil: [
		{ name: 'Brasilia', timeZoneId: 'E. South America Standard Time' },
		{ name: 'São Paulo', timeZoneId: 'E. South America Standard Time' },
		{
			name: 'Rio de Janeiro',
			timeZoneId: 'E. South America Standard Time',
		},
		{ name: 'Manaus', timeZoneId: 'SA Western Standard Time' },
		{ name: 'Recife', timeZoneId: 'SA Eastern Standard Time' },
		{ name: 'Fortaleza', timeZoneId: 'SA Eastern Standard Time' },
		{ name: 'Salvador', timeZoneId: 'Bahia Standard Time' },
		{ name: 'Eirunepe', timeZoneId: 'SA Pacific Standard Time' },
	],
	'British Indian Ocean Territory': [{ name: 'Diego Garcia', timeZoneId: 'Central Asia Standard Time' }],
	Brunei: [
		{
			name: 'Bandar Seri Begawan',
			timeZoneId: 'Singapore Standard Time',
		},
	],
	Bulgaria: [{ name: 'Sofia', timeZoneId: 'FLE Standard Time' }],
	'Burkina Faso': [{ name: 'Ouagadougou', timeZoneId: 'Greenwich Standard Time' }],
	Burundi: [{ name: 'Gitega', timeZoneId: 'South Africa Standard Time' }],
	'Cabo Verde': [{ name: 'Praia', timeZoneId: 'Cape Verde Standard Time' }],
	Cambodia: [{ name: 'Phnom Penh', timeZoneId: 'SE Asia Standard Time' }],
	Cameroon: [{ name: 'Yaoundé', timeZoneId: 'W. Central Africa Standard Time' }],
	Canada: [
		{ name: 'Ottawa', timeZoneId: 'Eastern Standard Time' },
		{ name: 'Toronto', timeZoneId: 'Eastern Standard Time' },
		{ name: 'Vancouver', timeZoneId: 'Pacific Standard Time' },
		{ name: 'Calgary', timeZoneId: 'Mountain Standard Time' },
		{ name: 'Winnipeg', timeZoneId: 'Central Standard Time' },
		{ name: 'Halifax', timeZoneId: 'Atlantic Standard Time' },
		{ name: 'Regina', timeZoneId: 'Canada Central Standard Time' },
		{ name: 'Montreal', timeZoneId: 'Eastern Standard Time' },
	],
	'Cayman Islands': [{ name: 'George Town', timeZoneId: 'SA Pacific Standard Time' }],
	'Central African Republic': [{ name: 'Bangui', timeZoneId: 'W. Central Africa Standard Time' }],
	Chad: [
		{
			name: "N'Djamena",
			timeZoneId: 'W. Central Africa Standard Time',
		},
	],
	Chile: [
		{ name: 'Santiago', timeZoneId: 'Pacific SA Standard Time' },
		{
			name: 'Easter Island',
			timeZoneId: 'Easter Island Standard Time',
		},
	],
	China: [
		{ name: 'Beijing', timeZoneId: 'China Standard Time' },
		{ name: 'Shanghai', timeZoneId: 'China Standard Time' },
		{ name: 'Hong Kong SAR', timeZoneId: 'China Standard Time' },
	],
	'Christmas Island': [{ name: 'Flying Fish Cove', timeZoneId: 'SE Asia Standard Time' }],
	'Cocos (Keeling) Islands': [{ name: 'West Island', timeZoneId: 'Myanmar Standard Time' }],
	Colombia: [{ name: 'Bogotá', timeZoneId: 'SA Pacific Standard Time' }],
	Comoros: [{ name: 'Moroni', timeZoneId: 'E. Africa Standard Time' }],
	Congo: [
		{
			name: 'Brazzaville',
			timeZoneId: 'W. Central Africa Standard Time',
		},
	],
	'Congo (DRC)': [
		{ name: 'Kinshasa', timeZoneId: 'W. Central Africa Standard Time' },
		{ name: 'Lubumbashi', timeZoneId: 'South Africa Standard Time' },
	],
	'Cook Islands': [{ name: 'Avarua', timeZoneId: 'Hawaiian Standard Time' }],
	'Costa Rica': [{ name: 'San José', timeZoneId: 'Central America Standard Time' }],
	Croatia: [{ name: 'Zagreb', timeZoneId: 'Central European Standard Time' }],
	Cuba: [{ name: 'Havana', timeZoneId: 'Eastern Standard Time' }],
	Curaçao: [{ name: 'Willemstad', timeZoneId: 'SA Western Standard Time' }],
	Cyprus: [{ name: 'Nicosia', timeZoneId: 'E. Europe Standard Time' }],
	'Czech Republic': [{ name: 'Prague', timeZoneId: 'Central Europe Standard Time' }],
	Denmark: [{ name: 'Copenhagen', timeZoneId: 'Romance Standard Time' }],
	Djibouti: [{ name: 'Djibouti', timeZoneId: 'E. Africa Standard Time' }],
	Dominica: [{ name: 'Roseau', timeZoneId: 'SA Western Standard Time' }],
	'Dominican Republic': [{ name: 'Santo Domingo', timeZoneId: 'SA Western Standard Time' }],
	Ecuador: [
		{ name: 'Quito', timeZoneId: 'SA Pacific Standard Time' },
		{ name: 'Galápagos', timeZoneId: 'Central America Standard Time' },
	],
	Egypt: [{ name: 'Cairo', timeZoneId: 'Egypt Standard Time' }],
	'El Salvador': [
		{
			name: 'San Salvador',
			timeZoneId: 'Central America Standard Time',
		},
	],
	'Equatorial Guinea': [{ name: 'Malabo', timeZoneId: 'W. Central Africa Standard Time' }],
	Eritrea: [{ name: 'Asmara', timeZoneId: 'E. Africa Standard Time' }],
	Estonia: [{ name: 'Tallinn', timeZoneId: 'FLE Standard Time' }],
	Ethiopia: [{ name: 'Addis Ababa', timeZoneId: 'E. Africa Standard Time' }],
	'Faroe Islands': [{ name: 'Tórshavn', timeZoneId: 'GMT Standard Time' }],
	'Fiji Islands': [{ name: 'Suva', timeZoneId: 'Fiji Standard Time' }],
	Finland: [{ name: 'Helsinki', timeZoneId: 'FLE Standard Time' }],
	France: [{ name: 'Paris', timeZoneId: 'Romance Standard Time' }],
	'French Guiana': [{ name: 'Cayenne', timeZoneId: 'SA Eastern Standard Time' }],
	'French Polynesia': [{ name: 'Papeete', timeZoneId: 'Hawaiian Standard Time' }],
	Gabon: [
		{
			name: 'Libreville',
			timeZoneId: 'W. Central Africa Standard Time',
		},
	],
	'Gambia, The': [{ name: 'Banjul', timeZoneId: 'Greenwich Standard Time' }],
	Georgia: [{ name: 'Tbilisi', timeZoneId: 'Georgian Standard Time' }],
	Germany: [
		{ name: 'Berlin', timeZoneId: 'W. Europe Standard Time' },
		{ name: 'Munich', timeZoneId: 'W. Europe Standard Time' },
		{ name: 'Frankfurt', timeZoneId: 'W. Europe Standard Time' },
	],
	Ghana: [{ name: 'Accra', timeZoneId: 'Greenwich Standard Time' }],
	Greece: [{ name: 'Athens', timeZoneId: 'GTB Standard Time' }],
	Greenland: [
		{ name: 'Nuuk', timeZoneId: 'Greenland Standard Time' },
		{ name: 'Scoresbysund', timeZoneId: 'Azores Standard Time' },
		{ name: 'Thule', timeZoneId: 'Atlantic Standard Time' },
	],
	Grenada: [{ name: "St. George's", timeZoneId: 'SA Western Standard Time' }],
	Guadeloupe: [{ name: 'Basse-Terre', timeZoneId: 'SA Western Standard Time' }],
	Guam: [{ name: 'Hagåtña', timeZoneId: 'West Pacific Standard Time' }],
	Guatemala: [
		{
			name: 'Guatemala City',
			timeZoneId: 'Central America Standard Time',
		},
	],
	Guernsey: [{ name: 'St. Peter Port', timeZoneId: 'GMT Standard Time' }],
	Guinea: [{ name: 'Conakry', timeZoneId: 'Greenwich Standard Time' }],
	'Guinea-Bissau': [{ name: 'Bissau', timeZoneId: 'Greenwich Standard Time' }],
	Guyana: [{ name: 'Georgetown', timeZoneId: 'SA Western Standard Time' }],
	Haiti: [{ name: 'Port-au-Prince', timeZoneId: 'Eastern Standard Time' }],
	Honduras: [
		{
			name: 'Tegucigalpa',
			timeZoneId: 'Central America Standard Time',
		},
	],
	'Hong Kong SAR': [{ name: 'Hong Kong', timeZoneId: 'China Standard Time' }],
	Hungary: [{ name: 'Budapest', timeZoneId: 'Central Europe Standard Time' }],
	Iceland: [{ name: 'Reykjavik', timeZoneId: 'Greenwich Standard Time' }],
	India: [
		{ name: 'New Delhi', timeZoneId: 'India Standard Time' },
		{ name: 'Mumbai', timeZoneId: 'India Standard Time' },
		{ name: 'Kolkata', timeZoneId: 'India Standard Time' },
		{ name: 'Chennai', timeZoneId: 'India Standard Time' },
	],
	Indonesia: [
		{ name: 'Jakarta', timeZoneId: 'SE Asia Standard Time' },
		{ name: 'Bandung', timeZoneId: 'SE Asia Standard Time' },
		{ name: 'Surabaya', timeZoneId: 'SE Asia Standard Time' },
		{ name: 'Denpasar', timeZoneId: 'Singapore Standard Time' },
	],
	Iran: [{ name: 'Tehran', timeZoneId: 'Iran Standard Time' }],
	Iraq: [{ name: 'Baghdad', timeZoneId: 'Arabic Standard Time' }],
	Ireland: [{ name: 'Dublin', timeZoneId: 'GMT Standard Time' }],
	'Isle of Man': [{ name: 'Douglas', timeZoneId: 'GMT Standard Time' }],
	Israel: [{ name: 'Jerusalem', timeZoneId: 'Israel Standard Time' }],
	Italy: [
		{ name: 'Rome', timeZoneId: 'W. Europe Standard Time' },
		{ name: 'Milan', timeZoneId: 'W. Europe Standard Time' },
	],
	Jamaica: [{ name: 'Kingston', timeZoneId: 'SA Pacific Standard Time' }],
	Japan: [
		{ name: 'Tokyo', timeZoneId: 'Tokyo Standard Time' },
		{ name: 'Osaka', timeZoneId: 'Tokyo Standard Time' },
	],
	Jersey: [{ name: 'Saint Helier', timeZoneId: 'GMT Standard Time' }],
	Jordan: [{ name: 'Amman', timeZoneId: 'Jordan Standard Time' }],
	Kazakhstan: [
		{ name: 'Astana', timeZoneId: 'Central Asia Standard Time' },
		{ name: 'Almaty', timeZoneId: 'Central Asia Standard Time' },
	],
	Kenya: [{ name: 'Nairobi', timeZoneId: 'E. Africa Standard Time' }],
	Kiribati: [{ name: 'Tarawa', timeZoneId: 'UTC+12' }],
	Korea: [{ name: 'Seoul', timeZoneId: 'Korea Standard Time' }],
	Kuwait: [{ name: 'Kuwait City', timeZoneId: 'Arab Standard Time' }],
	Kyrgyzstan: [{ name: 'Bishkek', timeZoneId: 'Central Asia Standard Time' }],
	Laos: [{ name: 'Vientiane', timeZoneId: 'SE Asia Standard Time' }],
	Latvia: [{ name: 'Riga', timeZoneId: 'FLE Standard Time' }],
	Lebanon: [{ name: 'Beirut', timeZoneId: 'Middle East Standard Time' }],
	Lesotho: [{ name: 'Maseru', timeZoneId: 'South Africa Standard Time' }],
	Liberia: [{ name: 'Monrovia', timeZoneId: 'Greenwich Standard Time' }],
	Libya: [{ name: 'Tripoli', timeZoneId: 'E. Europe Standard Time' }],
	Liechtenstein: [{ name: 'Vaduz', timeZoneId: 'W. Europe Standard Time' }],
	Lithuania: [{ name: 'Vilnius', timeZoneId: 'FLE Standard Time' }],
	Luxembourg: [{ name: 'Luxembourg City', timeZoneId: 'W. Europe Standard Time' }],
	'Macao SAR': [{ name: 'Macau', timeZoneId: 'China Standard Time' }],
	Madagascar: [{ name: 'Antananarivo', timeZoneId: 'E. Africa Standard Time' }],
	Malawi: [{ name: 'Lilongwe', timeZoneId: 'South Africa Standard Time' }],
	Malaysia: [
		{ name: 'Kuala Lumpur', timeZoneId: 'Singapore Standard Time' },
		{ name: 'Kuching', timeZoneId: 'Singapore Standard Time' },
	],
	Maldives: [{ name: 'Malé', timeZoneId: 'West Asia Standard Time' }],
	Mali: [{ name: 'Bamako', timeZoneId: 'Greenwich Standard Time' }],
	Malta: [{ name: 'Valletta', timeZoneId: 'W. Europe Standard Time' }],
	'Marshall Islands': [{ name: 'Majuro', timeZoneId: 'UTC+12' }],
	Martinique: [{ name: 'Fort-de-France', timeZoneId: 'SA Western Standard Time' }],
	Mauritania: [{ name: 'Nouakchott', timeZoneId: 'Greenwich Standard Time' }],
	Mauritius: [{ name: 'Port Louis', timeZoneId: 'Mauritius Standard Time' }],
	Mexico: [
		{
			name: 'Mexico City',
			timeZoneId: 'Central Standard Time (Mexico)',
		},
		{ name: 'Monterrey', timeZoneId: 'Central Standard Time (Mexico)' },
		{ name: 'Cancun', timeZoneId: 'Eastern Standard Time (Mexico)' },
		{ name: 'Tijuana', timeZoneId: 'Pacific Standard Time (Mexico)' },
		{
			name: 'Chihuahua',
			timeZoneId: 'Mountain Standard Time (Mexico)',
		},
	],
	Micronesia: [{ name: 'Palikir', timeZoneId: 'West Pacific Standard Time' }],
	Moldova: [{ name: 'Chișinău', timeZoneId: 'GTB Standard Time' }],
	Monaco: [{ name: 'Monaco', timeZoneId: 'W. Europe Standard Time' }],
	Mongolia: [{ name: 'Ulaanbaatar', timeZoneId: 'Ulaanbaatar Standard Time' }],
	Montenegro: [{ name: 'Podgorica', timeZoneId: 'Central European Standard Time' }],
	Montserrat: [{ name: 'Plymouth', timeZoneId: 'SA Western Standard Time' }],
	Morocco: [{ name: 'Casablanca', timeZoneId: 'Morocco Standard Time' }],
	Mozambique: [{ name: 'Maputo', timeZoneId: 'South Africa Standard Time' }],
	Myanmar: [{ name: 'Naypyidaw', timeZoneId: 'Myanmar Standard Time' }],
	Namibia: [{ name: 'Windhoek', timeZoneId: 'Namibia Standard Time' }],
	Nauru: [{ name: 'Yaren', timeZoneId: 'UTC+12' }],
	Nepal: [{ name: 'Kathmandu', timeZoneId: 'Nepal Standard Time' }],
	Netherlands: [
		{ name: 'Amsterdam', timeZoneId: 'W. Europe Standard Time' },
		{ name: 'Rotterdam', timeZoneId: 'W. Europe Standard Time' },
	],
	'New Caledonia': [{ name: 'Nouméa', timeZoneId: 'Central Pacific Standard Time' }],
	'New Zealand': [
		{ name: 'Wellington', timeZoneId: 'New Zealand Standard Time' },
		{ name: 'Auckland', timeZoneId: 'New Zealand Standard Time' },
	],
	Nicaragua: [{ name: 'Managua', timeZoneId: 'Central America Standard Time' }],
	Niger: [{ name: 'Niamey', timeZoneId: 'W. Central Africa Standard Time' }],
	Nigeria: [{ name: 'Abuja', timeZoneId: 'W. Central Africa Standard Time' }],
	Niue: [{ name: 'Alofi', timeZoneId: 'UTC-11' }],
	'Norfolk Island': [{ name: 'Kingston', timeZoneId: 'Central Pacific Standard Time' }],
	'North Korea': [{ name: 'Pyongyang', timeZoneId: 'Korea Standard Time' }],
	'Northern Mariana Islands': [{ name: 'Saipan', timeZoneId: 'West Pacific Standard Time' }],
	Norway: [{ name: 'Oslo', timeZoneId: 'W. Europe Standard Time' }],
	Oman: [{ name: 'Muscat', timeZoneId: 'Arabian Standard Time' }],
	Pakistan: [{ name: 'Islamabad', timeZoneId: 'Pakistan Standard Time' }],
	Palau: [{ name: 'Ngerulmud', timeZoneId: 'Tokyo Standard Time' }],
	'Palestinian Authority': [{ name: 'Ramallah', timeZoneId: 'Egypt Standard Time' }],
	Panama: [{ name: 'Panama City', timeZoneId: 'SA Pacific Standard Time' }],
	'Papua New Guinea': [{ name: 'Port Moresby', timeZoneId: 'West Pacific Standard Time' }],
	Paraguay: [{ name: 'Asunción', timeZoneId: 'Paraguay Standard Time' }],
	Peru: [{ name: 'Lima', timeZoneId: 'SA Pacific Standard Time' }],
	Philippines: [{ name: 'Manila', timeZoneId: 'Singapore Standard Time' }],
	'Pitcairn Islands': [{ name: 'Adamstown', timeZoneId: 'Pacific Standard Time' }],
	Poland: [{ name: 'Warsaw', timeZoneId: 'Central European Standard Time' }],
	Portugal: [
		{ name: 'Lisbon', timeZoneId: 'GMT Standard Time' },
		{ name: 'Madeira', timeZoneId: 'GMT Standard Time' },
		{ name: 'Azores', timeZoneId: 'Azores Standard Time' },
	],
	'Puerto Rico': [{ name: 'San Juan', timeZoneId: 'SA Western Standard Time' }],
	Qatar: [{ name: 'Doha', timeZoneId: 'Arab Standard Time' }],
	Reunion: [{ name: 'Saint-Denis', timeZoneId: 'Mauritius Standard Time' }],
	Romania: [{ name: 'Bucharest', timeZoneId: 'GTB Standard Time' }],
	Russia: [
		{ name: 'Moscow', timeZoneId: 'Russian Standard Time' },
		{ name: 'Saint Petersburg', timeZoneId: 'Russian Standard Time' },
		{ name: 'Kaliningrad', timeZoneId: 'Kaliningrad Standard Time' },
		{ name: 'Samara', timeZoneId: 'Russia Time Zone 3' },
		{ name: 'Yekaterinburg', timeZoneId: 'Ekaterinburg Standard Time' },
		{ name: 'Omsk', timeZoneId: 'Omsk Standard Time' },
		{
			name: 'Novosibirsk',
			timeZoneId: 'N. Central Asia Standard Time',
		},
		{ name: 'Krasnoyarsk', timeZoneId: 'North Asia Standard Time' },
		{ name: 'Irkutsk', timeZoneId: 'North Asia East Standard Time' },
		{ name: 'Yakutsk', timeZoneId: 'Yakutsk Standard Time' },
		{ name: 'Vladivostok', timeZoneId: 'Vladivostok Standard Time' },
		{ name: 'Magadan', timeZoneId: 'Magadan Standard Time' },
		{ name: 'Kamchatka', timeZoneId: 'Russia Time Zone 11' },
	],
	Rwanda: [{ name: 'Kigali', timeZoneId: 'South Africa Standard Time' }],
	'Saint Kitts and Nevis': [{ name: 'Basseterre', timeZoneId: 'SA Western Standard Time' }],
	'Saint Lucia': [{ name: 'Castries', timeZoneId: 'SA Western Standard Time' }],
	Samoa: [{ name: 'Apia', timeZoneId: 'Samoa Standard Time' }],
	'Saudi Arabia': [{ name: 'Riyadh', timeZoneId: 'Arab Standard Time' }],
	Senegal: [{ name: 'Dakar', timeZoneId: 'Greenwich Standard Time' }],
	Serbia: [{ name: 'Belgrade', timeZoneId: 'Central Europe Standard Time' }],
	Seychelles: [{ name: 'Victoria', timeZoneId: 'Mauritius Standard Time' }],
	'Sierra Leone': [{ name: 'Freetown', timeZoneId: 'Greenwich Standard Time' }],
	Singapore: [{ name: 'Singapore', timeZoneId: 'Singapore Standard Time' }],
	Slovakia: [{ name: 'Bratislava', timeZoneId: 'Central Europe Standard Time' }],
	Slovenia: [{ name: 'Ljubljana', timeZoneId: 'Central Europe Standard Time' }],
	'Solomon Islands': [{ name: 'Honiara', timeZoneId: 'Central Pacific Standard Time' }],
	Somalia: [{ name: 'Mogadishu', timeZoneId: 'E. Africa Standard Time' }],
	'South Africa': [{ name: 'Pretoria', timeZoneId: 'South Africa Standard Time' }],
	'South Sudan': [{ name: 'Juba', timeZoneId: 'E. Africa Standard Time' }],
	Spain: [
		{ name: 'Madrid', timeZoneId: 'Romance Standard Time' },
		{ name: 'Barcelona', timeZoneId: 'Romance Standard Time' },
	],
	'Sri Lanka': [{ name: 'Colombo', timeZoneId: 'Sri Lanka Standard Time' }],
	Sudan: [{ name: 'Khartoum', timeZoneId: 'E. Africa Standard Time' }],
	Suriname: [{ name: 'Paramaribo', timeZoneId: 'SA Eastern Standard Time' }],
	Swaziland: [{ name: 'Mbabane', timeZoneId: 'South Africa Standard Time' }],
	Sweden: [{ name: 'Stockholm', timeZoneId: 'W. Europe Standard Time' }],
	Switzerland: [
		{ name: 'Bern', timeZoneId: 'W. Europe Standard Time' },
		{ name: 'Zurich', timeZoneId: 'W. Europe Standard Time' },
	],
	Syria: [{ name: 'Damascus', timeZoneId: 'Syria Standard Time' }],
	Taiwan: [{ name: 'Taipei', timeZoneId: 'Taipei Standard Time' }],
	Tajikistan: [{ name: 'Dushanbe', timeZoneId: 'West Asia Standard Time' }],
	Tanzania: [{ name: 'Dodoma', timeZoneId: 'E. Africa Standard Time' }],
	Thailand: [{ name: 'Bangkok', timeZoneId: 'SE Asia Standard Time' }],
	Togo: [{ name: 'Lomé', timeZoneId: 'Greenwich Standard Time' }],
	Tokelau: [{ name: 'Fakaofo', timeZoneId: 'Tonga Standard Time' }],
	Tonga: [{ name: "Nuku'alofa", timeZoneId: 'Tonga Standard Time' }],
	'Trinidad and Tobago': [{ name: 'Port of Spain', timeZoneId: 'SA Western Standard Time' }],
	Tunisia: [{ name: 'Tunis', timeZoneId: 'W. Central Africa Standard Time' }],
	Türkiye: [{ name: 'Istanbul', timeZoneId: 'Turkey Standard Time' }],
	Turkmenistan: [{ name: 'Ashgabat', timeZoneId: 'West Asia Standard Time' }],
	'Turks and Caicos Islands': [{ name: 'Cockburn Town', timeZoneId: 'Eastern Standard Time' }],
	Tuvalu: [{ name: 'Funafuti', timeZoneId: 'UTC+12' }],
	Uganda: [{ name: 'Kampala', timeZoneId: 'E. Africa Standard Time' }],
	Ukraine: [
		{ name: 'Kyiv', timeZoneId: 'FLE Standard Time' },
		{ name: 'Lviv', timeZoneId: 'FLE Standard Time' },
	],
	'United Arab Emirates': [{ name: 'Abu Dhabi', timeZoneId: 'Arabian Standard Time' }],
	'United Kingdom': [
		{ name: 'London', timeZoneId: 'GMT Standard Time' },
		{ name: 'Edinburgh', timeZoneId: 'GMT Standard Time' },
	],
	'United States': [
		{ name: 'New York', timeZoneId: 'Eastern Standard Time' },
		{ name: 'Chicago', timeZoneId: 'Central Standard Time' },
		{ name: 'Denver', timeZoneId: 'Mountain Standard Time' },
		{ name: 'Los Angeles', timeZoneId: 'Pacific Standard Time' },
		{ name: 'Phoenix', timeZoneId: 'US Mountain Standard Time' },
		{ name: 'Anchorage', timeZoneId: 'Alaskan Standard Time' },
		{ name: 'Honolulu', timeZoneId: 'Hawaiian Standard Time' },
		{ name: 'Indianapolis', timeZoneId: 'US Eastern Standard Time' },
	],
	Uruguay: [{ name: 'Montevideo', timeZoneId: 'Montevideo Standard Time' }],
	Uzbekistan: [{ name: 'Tashkent', timeZoneId: 'West Asia Standard Time' }],
	Vanuatu: [{ name: 'Port Vila', timeZoneId: 'Central Pacific Standard Time' }],
	'Vatican City': [{ name: 'Vatican City', timeZoneId: 'W. Europe Standard Time' }],
	Vietnam: [{ name: 'Hanoi', timeZoneId: 'SE Asia Standard Time' }],
	'Virgin Islands, U.S.': [
		{
			name: 'Charlotte Amalie',
			timeZoneId: 'SA Western Standard Time',
		},
	],
	'Wallis and Futuna': [{ name: 'Mata-Utu', timeZoneId: 'UTC+12' }],
	Yemen: [{ name: "Sana'a", timeZoneId: 'Arab Standard Time' }],
	Zambia: [{ name: 'Lusaka', timeZoneId: 'South Africa Standard Time' }],
	Zimbabwe: [{ name: 'Harare', timeZoneId: 'South Africa Standard Time' }],
	Venezuela: [{ name: 'Caracas', timeZoneId: 'Venezuela Standard Time' }],
	'Bouvet Island': [{ name: 'Bouvet Island', timeZoneId: 'UTC' }],
	'Timor-Leste': [{ name: 'Dili', timeZoneId: 'Tokyo Standard Time' }],
	'French Southern and Antarctic Lands': [
		{
			name: 'Port-aux-Français',
			timeZoneId: 'West Asia Standard Time',
		},
	],
	'Heard Island and McDonald Islands': [{ name: 'Heard Island', timeZoneId: 'Mauritius Standard Time' }],
	'Jan Mayen': [{ name: 'Jan Mayen', timeZoneId: 'W. Europe Standard Time' }],
	Kosovo: [{ name: 'Pristina', timeZoneId: 'Central European Standard Time' }],
	Mayotte: [{ name: 'Mamoudzou', timeZoneId: 'E. Africa Standard Time' }],
	'North Macedonia': [{ name: 'Skopje', timeZoneId: 'Central European Standard Time' }],
	'Saint Barthélemy': [{ name: 'Gustavia', timeZoneId: 'SA Western Standard Time' }],
	'Saint Helena, Ascension and Tristan da Cunha': [{ name: 'Jamestown', timeZoneId: 'Greenwich Standard Time' }],
	'Saint Martin': [{ name: 'Marigot', timeZoneId: 'SA Western Standard Time' }],
	'Saint Pierre and Miquelon': [{ name: 'Saint-Pierre', timeZoneId: 'Greenland Standard Time' }],
	'Saint Vincent and the Grenadines': [{ name: 'Kingstown', timeZoneId: 'SA Western Standard Time' }],
	'San Marino': [{ name: 'San Marino', timeZoneId: 'W. Europe Standard Time' }],
	'São Tomé and Príncipe': [{ name: 'São Tomé', timeZoneId: 'Greenwich Standard Time' }],
	'Sint Maarten': [{ name: 'Philipsburg', timeZoneId: 'SA Western Standard Time' }],
	'South Georgia and the South Sandwich Islands': [{ name: 'King Edward Point', timeZoneId: 'UTC-02' }],
	Svalbard: [{ name: 'Longyearbyen', timeZoneId: 'W. Europe Standard Time' }],
	'U.S. Minor Outlying Islands': [{ name: 'Wake Island', timeZoneId: 'UTC+12' }],
	'Virgin Islands, British': [{ name: 'Road Town', timeZoneId: 'SA Western Standard Time' }],
};

@Component({
	selector: 'app-timezone-picker',
	templateUrl: './timezone-picker.component.html',
	styleUrls: ['./timezone-picker.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class TimezonePickerComponent implements OnInit {
	countries: string[] = Object.keys(TIMEZONE_MAPPING);
	regions: Region[] = [];

	@Input() selectedCountry: string = 'Denmark'; // Default country
	@Input() selectedRegion: string = 'Copenhagen'; // Default region
	timeZoneId: string | null = 'Romance Standard Time'; // Default time zone

	@Output() timeZoneChange = new EventEmitter<{
		country: string;
		region: string;
		timeZoneId: string | null;
	}>();

	constructor() {}

	ngOnInit(): void {
		this.initializeDefaultValues();
	}

	private initializeDefaultValues(): void {
		this.regions = this.getRegionsByCountry(this.selectedCountry);

		if (this.selectedRegion && this.regions.length > 0) {
			this.timeZoneId = this.getTimeZoneId(this.selectedCountry, this.selectedRegion);
		}

		this.emitTimeZoneChange();
	}

	onCountryChange(): void {
		this.regions = this.getRegionsByCountry(this.selectedCountry);
		this.selectedRegion = '';
		this.timeZoneId = null;
		this.emitTimeZoneChange();
	}

	onRegionChange(): void {
		this.timeZoneId = this.getTimeZoneId(this.selectedCountry, this.selectedRegion);
		this.emitTimeZoneChange();
	}

	private emitTimeZoneChange(): void {
		this.timeZoneChange.emit({
			country: this.selectedCountry,
			region: this.selectedRegion,
			timeZoneId: this.timeZoneId,
		});
	}

	getRegionsByCountry(country: string): Region[] {
		return country ? TIMEZONE_MAPPING[country] || [] : [];
	}

	getTimeZoneId(country: string, regionName: string): string | null {
		if (!country || !regionName) return null;
		const regions = this.getRegionsByCountry(country);
		const region = regions.find((r) => r.name === regionName);
		return region?.timeZoneId || null;
	}
}
